import './numberIsNan'



// WEBPACK FOOTER //
// ./src/polyfills/index.js